import classNames from "classnames"
import { usePropsObject } from "@/lib/contexts/appContext"
import Block from "@/components/wrappers/block"
import styles from "./article-teasers.module.css"
import dynamic from "next/dynamic"
import Link from "next/link"

const cards = {
  article: dynamic(() => import("@/common/cards/article/article")),
  "bmv-project": dynamic(() => import("@/common/cards/project/project"))
}
export default function ArticleTeasers({ block }) {
  const { attrs } = block
  const { theme } = usePropsObject()

  if (attrs.articles.length === 0) {
    return null
  }

  const Card = cards[attrs.type] ?? cards.article

  return (
    <Block
      block={block}
      width="bleed"
      gap={attrs?.blockGap ?? "normal"}
      innerWrapper={true}
      className={classNames(styles.wrapper, "bg-color-" + attrs.bgColor, {
        "text-white": theme?.bgColor === "black"
      })}>
      {(attrs.heading || attrs.category.label) && (
        <h2>
          {attrs.heading}
          {attrs?.showExtraHeading && (
            <Link
              className="term"
              href={attrs.category.url ?? ""}
              prefetch={false}>
              {attrs.category.label}
            </Link>
          )}
        </h2>
      )}
      {attrs?.text && <p dangerouslySetInnerHTML={{ __html: attrs.text }}></p>}
      <ul className="article-grid">
        {attrs.articles.map((post, index) => {
          return (
            <li key={index}>
              <Card
                post={post}
                showImage={attrs?.showImage}
                showTag={attrs?.showTag}
                showExcerpt={attrs?.showExcerpt}
                showDateline={attrs?.showDateline}
              />
            </li>
          )
        })}
      </ul>
    </Block>
  )
}
